import {createStore, combineReducers, compose } from 'redux';
import persistente from 'redux-localstorage';
const defaultState = []

function clienteReducer (state = defaultState, action) {
    switch(action.type){
        
            case 'SET_CLIENTE':
            const {password, usuario} = action;
            return { 
                password, 
                usuario
            }

            case 'OUT_CLIENTE':
               return ''

        default:
            return state;
    }
}

function tokenReducer (state='',action){
    switch(action.type){
        
        case 'SET_TOKEN':
        const {token} = action;
        return { 
            token
        }
    
        case 'OUT_TOKEN':
            return ''

        default:
            return state;
    }
}


let rootReducer = combineReducers({
    usuario1: clienteReducer,
    token: tokenReducer,

});

let menupersistente = compose(persistente());

export default createStore(rootReducer,{},menupersistente);